<template>
  <div id="broker360-pet-app"
       :style="{'--accent-color': customColor}"
       class="broker360-pet-app">
    <router-view/>
  </div>

</template>
  <input id="broker360-default-language" type="hidden" name="language" value="de"/>
  <input id="broker360-layout" type="hidden" name="layout" value="layoutOne"/>
<style lang="scss">
  @import "assets/project";
</style>

<script>

export default {
  data() {
    return {
      customColor: window.customColor,
    };
  },
};
</script>
